import React from 'react';
export function BottleToGutDivider() {
  return <div className="relative w-full overflow-hidden" style={{
    backgroundColor: '#ffffff'
  }} data-id="element-65">
      

      <style data-id="element-66">{`
        @keyframes bottleToGutWave {
          0%, 100% {
            transform: translateX(0) scaleY(1);
          }
          50% {
            transform: translateX(-25px) scaleY(1.05);
          }
        }
        
        @media (prefers-reduced-motion: reduce) {
          svg path {
            animation: none !important;
          }
        }
      `}</style>
    </div>;
}